<script setup lang="ts">
import {type HTMLAttributes, computed} from 'vue'
import {DropdownMenuItem, type DropdownMenuItemProps, useForwardProps} from 'radix-vue'
import {cn} from '@/lib/utils'

const props = defineProps<DropdownMenuItemProps & { class?: HTMLAttributes['class'], inset?: boolean }>()

const delegatedProps = computed(() => {
    const {class: _, ...delegated} = props

    return delegated
})

const forwardedProps = useForwardProps(delegatedProps)
</script>

<template>
    <DropdownMenuItem
        v-bind="forwardedProps"
        :class="cn(
      'relative flex cursor-pointer select-none items-center rounded-lg p-3 text-sm outline-none font-semibold active:scale-[0.97] hover:bg-gray-dark data-[disabled]:pointer-events-none data-[disabled]:opacity-50 transition-all duration-200',
      inset && 'pl-8',
      props.class,
    )"
    >
        <slot/>
    </DropdownMenuItem>
</template>
